'use client';
import Image from 'next/image';
import React from 'react';
import dynamic from 'next/dynamic';

import KEY from '@/components/common/keylist';

const ContactInfoPmigjcAnantam = () => {
    return (
        <>
            <div className="md:col-span-12 lg:col-span-5">
                <div
                    className="bg-white dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid rounded-lg xl:p-[30px] lg:py-5 lg:px-[15px] md:py-5 md:px-[15px] py-5 px-[15px] lg:mb-10 md:mb-10 mb-6"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                >
                    <div className="font-bold text-2xl mb-2.5">
                        <span>Real Engineering</span> <span className="gradient-text">Real Impact</span>
                    </div>

                    <div className="rating-section">
                        <KEY text="AI Enablement for Enterprises & SMEs" className="" />
                        <KEY text="Enterprise Digital Transformation Expertise" className="" />
                        <KEY text="Strong Product Engineering Capabilities" className="" />
                    </div>
                </div>

                <div
                    className="bg-white dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid rounded-lg xl:py-[30px] xl:px-6 lg:py-5 lg:px-[15px] md:py-5 md:px-[15px] py-5 px-[15px] lg:mb-10 md:mb-10 mb-6"
                    data-aos="fade-up"
                    data-aos-duration={1000}
                >
                    <div className="flex items-center justify-between lg:justify-between md:justify-center lg:gap-2.5 md:gap-7 gap-2 sepecification-pmigjc">
                        <Image src="/img/icons/ic-iso.svg" alt="ISO certified" title="ISO certified" width={80} height={80} />
                        <Image src="/img/icons/ic-cmmi.svg" alt="cmmi level" title="cmmi level" width={88} height={88} />
                        <Image
                            src="/img/icons/ic-industry.svg"
                            alt="Years of Experience"
                            title="Years of Experience"
                            width={116}
                            height={62}
                        />
                        <Image
                            src="/img/icons/ic-project.svg"
                            alt="Successful Projects"
                            title="Successful Projects"
                            width={116}
                            height={62}
                        />
                    </div>
                </div>

                <div className="rounded-lg" data-aos="fade-up" data-aos-duration={1000} data-aos-delay={200}>
                    <video playsInline autoPlay muted controls loop className="rounded-10 w-full">
                        <source src="media/PMI-video.mp4" type="video/mp4" />
                    </video>
                </div>
            </div>
        </>
    );
};

export default ContactInfoPmigjcAnantam;
